import { useState, useEffect } from "react";

import styled from "styled-components";
import Collapse from './Collapse'
import LoadingContent from '../../component/loading/LoadingContent'


const Section = styled.section`
  .txt-title center{
      margin-bottom: 10px;
  }
`;

export default function Index(props) {
    const [content, setContent] = useState(false);

    useEffect(() => {
        setContent(true)
    }, [])

    return (
        <Section
        className={"section-faq" + (props.className ? props.className : "")}
      >
          <div className="container">
            {!content ? <LoadingContent/>
            :
             <>
                <div className="section-heading">ถาม-ตอบ</div>
                <Collapse/>
             </>
            }
          </div>
      </Section>
    )
}
